// src/helpers/currencyHelper.js
import cookieHelper from './getCookieData';

/**
 * Standard Currencies Catalog
 */
export const CURRENCIES_CATALOG = [
  { code: 'INR', name: 'Indian Rupee', symbol: '₹', flag: '🇮🇳', decimal_places: 2, locale: 'en-IN' },
  { code: 'USD', name: 'US Dollar', symbol: '$', flag: '🇺🇸', decimal_places: 2, locale: 'en-US' },
  { code: 'GBP', name: 'Pound Sterling', symbol: '£', flag: '🇬🇧', decimal_places: 2, locale: 'en-GB' },
  { code: 'EUR', name: 'Euro', symbol: '€', flag: '🇪🇺', decimal_places: 2, locale: 'de-DE' },
  { code: 'NPR', name: 'Nepalese Rupee', symbol: 'रू', flag: '🇳🇵', decimal_places: 2, locale: 'ne-NP' },
  { code: 'CNY', name: 'Chinese Yuan', symbol: '¥', flag: '🇨🇳', decimal_places: 2, locale: 'zh-CN' },
  { code: 'AED', name: 'UAE Dirham', symbol: 'د.إ', flag: '🇦🇪', decimal_places: 2, locale: 'ar-AE' },
  { code: 'SAR', name: 'Saudi Riyal', symbol: 'ر.س', flag: '🇸🇦', decimal_places: 2, locale: 'ar-SA' },
  { code: 'AUD', name: 'Australian Dollar', symbol: 'A$', flag: '🇦🇺', decimal_places: 2, locale: 'en-AU' },
  { code: 'CAD', name: 'Canadian Dollar', symbol: 'C$', flag: '🇨🇦', decimal_places: 2, locale: 'en-CA' },
  { code: 'SGD', name: 'Singapore Dollar', symbol: 'S$', flag: '🇸🇬', decimal_places: 2, locale: 'en-SG' },
  { code: 'JPY', name: 'Japanese Yen', symbol: '¥', flag: '🇯🇵', decimal_places: 0, locale: 'ja-JP' },
  { code: 'KRW', name: 'South Korean Won', symbol: '₩', flag: '🇰🇷', decimal_places: 0, locale: 'ko-KR' },
  { code: 'KWD', name: 'Kuwaiti Dinar', symbol: 'د.ك', flag: '🇰🇼', decimal_places: 3, locale: 'ar-KW' },
  { code: 'BHD', name: 'Bahraini Dinar', symbol: '.د.ب', flag: '🇧🇭', decimal_places: 3, locale: 'ar-BH' },
  { code: 'OMR', name: 'Omani Rial', symbol: 'ر.ع.', flag: '🇴🇲', decimal_places: 3, locale: 'ar-OM' },
  { code: 'QAR', name: 'Qatari Riyal', symbol: 'ر.ق', flag: '🇶🇦', decimal_places: 2, locale: 'ar-QA' },
  { code: 'MYR', name: 'Malaysian Ringgit', symbol: 'RM', flag: '🇲🇾', decimal_places: 2, locale: 'en-MY' },
  { code: 'THB', name: 'Thai Baht', symbol: '฿', flag: '🇹🇭', decimal_places: 2, locale: 'th-TH' },
  { code: 'NZD', name: 'New Zealand Dollar', symbol: 'NZ$', flag: '🇳🇿', decimal_places: 2, locale: 'en-NZ' },
  { code: 'ZAR', name: 'South African Rand', symbol: 'R', flag: '🇿🇦', decimal_places: 2, locale: 'en-ZA' },
];

/**
 * Standard Countries Master
 */
export const COUNTRIES_CATALOG = [
  { code: 'IN', iso3: 'IND', name: 'India', flag: '🇮🇳', phone_code: '+91', default_currency: 'INR', default_timezone: 'Asia/Kolkata' },
  { code: 'NP', iso3: 'NPL', name: 'Nepal', flag: '🇳🇵', phone_code: '+977', default_currency: 'NPR', default_timezone: 'Asia/Kathmandu' },
  { code: 'CN', iso3: 'CHN', name: 'China', flag: '🇨🇳', phone_code: '+86', default_currency: 'CNY', default_timezone: 'Asia/Shanghai' },
  { code: 'US', iso3: 'USA', name: 'United States', flag: '🇺🇸', phone_code: '+1', default_currency: 'USD', default_timezone: 'America/New_York' },
  { code: 'GB', iso3: 'GBR', name: 'United Kingdom', flag: '🇬🇧', phone_code: '+44', default_currency: 'GBP', default_timezone: 'Europe/London' },
  { code: 'AE', iso3: 'ARE', name: 'United Arab Emirates', flag: '🇦🇪', phone_code: '+971', default_currency: 'AED', default_timezone: 'Asia/Dubai' },
  { code: 'SA', iso3: 'SAU', name: 'Saudi Arabia', flag: '🇸🇦', phone_code: '+966', default_currency: 'SAR', default_timezone: 'Asia/Riyadh' },
  { code: 'AU', iso3: 'AUS', name: 'Australia', flag: '🇦🇺', phone_code: '+61', default_currency: 'AUD', default_timezone: 'Australia/Sydney' },
  { code: 'CA', iso3: 'CAN', name: 'Canada', flag: '🇨🇦', phone_code: '+1', default_currency: 'CAD', default_timezone: 'America/Toronto' },
  { code: 'SG', iso3: 'SGP', name: 'Singapore', flag: '🇸🇬', phone_code: '+65', default_currency: 'SGD', default_timezone: 'Asia/Singapore' },
  { code: 'JP', iso3: 'JPN', name: 'Japan', flag: '🇯🇵', phone_code: '+81', default_currency: 'JPY', default_timezone: 'Asia/Tokyo' },
  { code: 'DE', iso3: 'DEU', name: 'Germany', flag: '🇩🇪', phone_code: '+49', default_currency: 'EUR', default_timezone: 'Europe/Berlin' },
  { code: 'FR', iso3: 'FRA', name: 'France', flag: '🇫🇷', phone_code: '+33', default_currency: 'EUR', default_timezone: 'Europe/Paris' },
  { code: 'KW', iso3: 'KWT', name: 'Kuwait', flag: '🇰🇼', phone_code: '+965', default_currency: 'KWD', default_timezone: 'Asia/Kuwait' },
  { code: 'BH', iso3: 'BHR', name: 'Bahrain', flag: '🇧🇭', phone_code: '+973', default_currency: 'BHD', default_timezone: 'Asia/Bahrain' },
  { code: 'OM', iso3: 'OMN', name: 'Oman', flag: '🇴🇲', phone_code: '+968', default_currency: 'OMR', default_timezone: 'Asia/Muscat' },
  { code: 'QA', iso3: 'QAT', name: 'Qatar', flag: '🇶🇦', phone_code: '+974', default_currency: 'QAR', default_timezone: 'Asia/Qatar' },
  { code: 'MY', iso3: 'MYS', name: 'Malaysia', flag: '🇲🇾', phone_code: '+60', default_currency: 'MYR', default_timezone: 'Asia/Kuala_Lumpur' },
  { code: 'TH', iso3: 'THA', name: 'Thailand', flag: '🇹🇭', phone_code: '+66', default_currency: 'THB', default_timezone: 'Asia/Bangkok' },
  { code: 'NZ', iso3: 'NZL', name: 'New Zealand', flag: '🇳🇿', phone_code: '+64', default_currency: 'NZD', default_timezone: 'Pacific/Auckland' },
  { code: 'ZA', iso3: 'ZAF', name: 'South Africa', flag: '🇿🇦', phone_code: '+27', default_currency: 'ZAR', default_timezone: 'Africa/Johannesburg' },
];

/**
 * Get the active clinic's configured currency_code from cookie or storage
 */
export const getActiveClinicCurrency = () => {
  try {
    const clinicCookie = cookieHelper.getCookie('_c');
    if (clinicCookie) {
      const decoded = JSON.parse(atob(clinicCookie));
      if (decoded?.currency_code) return decoded.currency_code;
    }
  } catch (e) {
    // ignore
  }
  return 'INR';
};

/**
 * Get currency metadata by code
 */
export const getCurrencyMeta = (currencyCode = 'INR') => {
  const code = (currencyCode || 'INR').toUpperCase().trim();
  return CURRENCIES_CATALOG.find((c) => c.code === code) || {
    code: 'INR',
    name: 'Indian Rupee',
    symbol: '₹',
    decimal_places: 2,
    locale: 'en-IN',
  };
};

/**
 * Get currency symbol by code
 */
export const getCurrencySymbol = (currencyCode) => {
  const meta = getCurrencyMeta(currencyCode || getActiveClinicCurrency());
  return meta.symbol || '₹';
};

/**
 * Suggest country default timezone & currency
 */
export const suggestCountryDefaults = (countryCodeOrName) => {
  if (!countryCodeOrName) return COUNTRIES_CATALOG[0];
  const query = String(countryCodeOrName).trim().toUpperCase();
  const match = COUNTRIES_CATALOG.find(
    (c) => c.code.toUpperCase() === query || c.iso3.toUpperCase() === query || c.name.toUpperCase() === query
  );
  return match || COUNTRIES_CATALOG[0];
};

/**
 * Format Monetary Value safely according to currency & locale
 * @param {number|string} amount
 * @param {string} [currencyCode] - ISO code (e.g. 'INR', 'USD', 'GBP', 'EUR', 'NPR', 'CNY', 'AED', 'JPY', 'KWD')
 * @param {object} [options] - { decimals, display, locale, showCode }
 */
export const formatMoney = (amount, currencyCode, options = {}) => {
  const num = Number(amount) || 0;
  const targetCurrency = currencyCode || getActiveClinicCurrency() || 'INR';
  const meta = getCurrencyMeta(targetCurrency);

  const decimals = options.decimals !== undefined ? options.decimals : meta.decimal_places;
  const locale = options.locale || meta.locale || 'en-US';

  try {
    const formatted = new Intl.NumberFormat(locale, {
      style: 'currency',
      currency: meta.code,
      currencyDisplay: options.display || 'symbol',
      minimumFractionDigits: decimals,
      maximumFractionDigits: decimals,
    }).format(num);

    if (options.showCode && meta.code !== 'INR') {
      return `${formatted} ${meta.code}`;
    }
    return formatted;
  } catch (err) {
    return `${meta.symbol}${num.toFixed(decimals)}`;
  }
};
